import { Injectable } from '@angular/core';
import { LU_MaterialServiceServiceBase } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_MaterialServiceService extends LU_MaterialServiceServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
